export default "__VITE_ASSET__BzzKQShP__"